import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FolderKanban, BookText, GitBranch, Inbox, Cpu, Settings } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ projects: 0, posts: 0, timeline: 0, messages: 0, skills: 0, unread: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/projects").catch(() => ({ data: [] })),
      api.get("/blog/admin").catch(() => ({ data: [] })),
      api.get("/timeline").catch(() => ({ data: [] })),
      api.get("/contact").catch(() => ({ data: [] })),
      api.get("/skills").catch(() => ({ data: [] })),
    ]).then(([p, b, t, m, s]) => {
      setStats({
        projects: p.data.length,
        posts: b.data.length,
        timeline: t.data.length,
        messages: m.data.length,
        skills: s.data.length,
        unread: m.data.filter((x) => !x.read).length,
      });
    });
  }, []);

  const cards = [
    { label: "Projects", value: stats.projects, to: "/admin/projects", icon: FolderKanban },
    { label: "Blog posts", value: stats.posts, to: "/admin/blog", icon: BookText },
    { label: "Timeline events", value: stats.timeline, to: "/admin/timeline", icon: GitBranch },
    { label: "Skills", value: stats.skills, to: "/admin/skills", icon: Cpu },
    { label: "Unread messages", value: stats.unread, to: "/admin/messages", icon: Inbox },
    { label: "Site config", value: "→", to: "/admin/site", icon: Settings },
  ];

  return (
    <div>
      <header className="mb-10">
        <p className="label-xs">Dashboard</p>
        <h1 className="mt-2 font-heading font-black text-4xl md:text-5xl tracking-tighter">Overview</h1>
        <p className="mt-2 text-muted-foreground text-sm">Everything about your portfolio site, in one place.</p>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-dashboard-cards">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            className="group border border-border p-6 rounded-sm hover:border-foreground hover:bg-secondary/40 transition-colors"
            data-testid={`dashboard-card-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="flex items-center justify-between">
              <p className="label-xs">{c.label}</p>
              <c.icon className="h-4 w-4 text-muted-foreground group-hover:text-[var(--brand-accent)] transition-colors" />
            </div>
            <p className="mt-4 font-heading text-4xl font-black tracking-tighter">{c.value}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
